import { useQueryClient } from '@tanstack/react-query';
import type { UseMutationResult } from '@tanstack/react-query';
import { useBffPatchMutation } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import { useBasket } from './useBasket';
import type { Basket, UpdateCartProductItems } from './model';

export const useUpdateProductItemQuantities = (): UseMutationResult<
    Basket,
    unknown,
    UpdateCartProductItems
> => {
    const { data } = useBasket();
    const queryClient = useQueryClient();

    return useBffPatchMutation<Basket, UpdateCartProductItems>(
        `/baskets/${data?.basketId}/product-item-quantities`,
        [],
        [],
        {
            basketCustomerId: data?.customerInfo?.customerId,
            onSuccess: async (basket): Promise<void> => {
                queryClient.setQueryData([BffQueryKey.BASKET], basket);

                await Promise.all([
                    queryClient.invalidateQueries([BffQueryKey.BASKET_AVAILABILITY], {
                        exact: false,
                    }),
                    queryClient.invalidateQueries(
                        [BffQueryKey.BASKET_INVENTORY, String(data?.basketId)],
                        {
                            exact: false,
                        },
                    ),
                ]);
            },
        },
    );
};
